module.exports = __webpack_public_path__ + "static/media/flatBedTruck_salmon.2c14ca45.svg";